import { render, staticRenderFns } from "./MoveLists.vue?vue&type=template&id=36ca4854&scoped=true&lang=html&"
import script from "./MoveLists.vue?vue&type=script&lang=js&"
export * from "./MoveLists.vue?vue&type=script&lang=js&"
import style0 from "./MoveLists.vue?vue&type=style&index=0&id=36ca4854&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ca4854",
  null
  
)

export default component.exports